import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'util';

const initialState = {
    county: [],
    dashBoard: {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setCounty(state, action) {
            state.county = json.toJSON(action.payload);
        },
        setDashBoard(state, action) {
            state.dashBoard = action.payload;
        }
    }
});

export const { setCounty, setDashBoard } = slice.actions;

export const selectCounty = state => json.fromJSON(state[name].county);
export const selectDashBoard = state => state[name].dashBoard;

const utilReducer = slice.reducer;
export default utilReducer;